import { useMutation } from '@tanstack/react-query'
import { deleteMeCategoryProfile } from '../../api/categories/category-tag'
import { useSession } from 'next-auth/react'

export const useDeleteCategoryById = (id: number) => {
  const { data } = useSession()

  // @ts-ignore
  return useMutation(async () => deleteMeCategoryProfile(data?.accessToken, id))
}
